import { createSelector } from '@ngrx/store';

export const selectBillingProfileState = (state: any) => state.billingProfile;

export const selectBillingProfileData = createSelector(
  selectBillingProfileState,
  (state) => state.data
);

export const selectBillingProfileLoading = createSelector(
  selectBillingProfileState,
  (state) => state.loading
);

export const selectBillingProfileError = createSelector(
  selectBillingProfileState,
  (state) => state.error
);

export const selectUpdateSuccess = createSelector(
  selectBillingProfileData,
  (state) => state ? state.data : null
);

export const selectUpdateFailure = createSelector(
  selectBillingProfileError,
  (state) => state ? state.error : null
);

export const selectSubmitSuccess = createSelector(
  selectBillingProfileData,
  (state) => state ? state.data : null
);

export const selectSubmitFailure = createSelector(
  selectBillingProfileError,
  (state) => state ? state.error : null
);

export const selectDeleteSuccess = createSelector(
  selectBillingProfileState,
  (state) => state.deleteSuccess
);

export const selectDeleteError = createSelector(
  selectBillingProfileState,
  (state) => state.deleteError
);
